import React, { useState, useEffect } from 'react';
import {  useParams } from 'react-router-dom';
import './Zatca.css';
import { useDispatch } from 'react-redux';
import { getUserById } from '../../../../redux/user/action';

const ZatcaOtpSuccess = () => {
  const [countdown, setCountdown] = useState(10);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (countdown === 0) return;

    const timerId = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [countdown]);

 

  useEffect(() => {
    const apiCallTimer = setTimeout(() => {
      if (id) {
        dispatch(getUserById(id));
      }
    }, 3000);

    return () => clearTimeout(apiCallTimer);
  }, [id, dispatch]);

  return (
    <div className="zatca-success-container">
      <div className="zatca-success-icon-wrapper">
        <svg
          className="zatca-success-checkmark"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52 52"
        >
          <circle
            className="zatca-success-checkmark-circle"
            cx="26"
            cy="26"
            r="25"
            fill="none"
          />
          <path
            className="zatca-success-checkmark-check"
            fill="none"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
          />
        </svg>
      </div>
      <h3 className="zatca-success-title">OTP Verification is Successful</h3>
      <p className="zatca-success-subtitle">
        Your ZATCA phase 2 Integration is completed
      </p>
      <button
        className="zatca-success-button"
        disabled={countdown > 0}
      >
        {countdown > 0
          ? `ZATCA Status will update in ${countdown} seconds`
          : 'View ZATCA Info'}
      </button>
    </div>
  );
};

export default ZatcaOtpSuccess;

